<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import AudioChip from 'next/message/chips/Audio.vue';
import { useMessageContext } from '../provider.js';

const { attachments, translations, contentAttributes, messageType } =
  useMessageContext();

const attachment = computed(() => {
  return attachments.value[0];
});

const spanishTranslation = computed(
  () =>
    translations.value?.es?.trim() ||
    contentAttributes.value?.translations?.es?.trim()
);
const showSpanishTranslation = computed(
  () =>
    messageType.value === 0 &&
    spanishTranslation.value &&
    spanishTranslation.value !== attachment.value?.transcribedText?.trim()
);
</script>

<template>
  <BaseBubble class="bg-transparent" data-bubble-name="audio">
    <AudioChip
      :attachment="attachment"
      class="p-2 text-n-slate-12 skip-context-menu"
    />
    <div
      v-if="showSpanishTranslation"
      class="mt-2 p-3 text-sm text-n-slate-12 bg-n-alpha-1 rounded-lg border border-n-weak"
    >
      <div class="mb-1 text-xs font-medium text-n-slate-11">
        Traducción al español
      </div>
      {{ spanishTranslation }}
    </div>
  </BaseBubble>
</template>
